/**
 * 文件名:
 * 作者: 胡建
 * 描述:  Number动态增加效果，可携带单位
 * 创建时间: 2021/7/23
 * */

// 针对整数
export function createNumber(target, timer, callback) {

    let targetTime = Date.now()
    let changeNumber = 0;

    return (function addNumber() {

        const currentTime = Date.now()
        const step = currentTime - targetTime;

        targetTime = currentTime;
        changeNumber += step * (Math.floor(target / timer))

        if (changeNumber < target) {

            callback && callback(changeNumber)
            requestAnimationFrame(addNumber)

        } else {

            callback && callback(target)

        }
    })()
}

// 针对浮点类型
export function createFloatNumber(target, timer, callback) {

    let strTarget = String(target),
        current1 = 0,
        current2 = 0,
        number1 = 0,
        number2 = 0,
        startTime = Date.now(),
        strList = strTarget.split(".");

    if (strList.length < 2) {

        strList.push('0')

    } else if (strList.length > 3) {

        callback && callback(new Error("请输入合法值"))

    }

    current1 = parseInt(strList[0])
    current2 = parseInt(strList[1])

    function start() {

        const currentTime = Date.now()
        const step = currentTime - startTime

        startTime = currentTime;
        number1 += step * (current1 / timer)
        number2 += step * (current2 / timer)

        if (number1 < current1 || number2 < current2) {

            callback && callback(parseFloat(`${parseInt(String(number1))}.${parseInt(String(number2))}`))
            requestAnimationFrame(start)

        } else {

            if (number1 >= current1) {
                number1 = current1
            }

            if (number2 >= current2) {
                number2 = current2
            }

            callback && callback(parseFloat(`${number1}.${number2}`))

        }
    }

    start()
}


export function bind(app) {
    app.directive("changNum", {
        inserted(el, binding) {
            if (!binding.value)
                return

            let list = binding.value
            if (typeof list[0] === 'string') {
                el.innerHTML = list[0]
                return;
            }

            if (list.length === 0 || list.length > 3) return;

            let target = list[0], timer = 100, unit = '';

            if (list.length === 2) {

                const value = list[1]

                if (typeof value === 'string') {
                    unit = value
                } else if (typeof value === 'number') {
                    timer = value
                }

            } else if (list.length === 3) {
                list.splice(0, 1)

                for (let i = 0; i < list.length; i++) {
                    const value = list[i]

                    if (typeof value === 'string') {
                        unit = value
                    } else if (typeof value === 'number') {
                        timer = value
                    }
                }
            }

            createFloatNumber(target, timer, (e) => {
                el.innerHTML = e + unit
            })
        }
    })
}



// WEBPACK FOOTER //
// ./src/utils/NumberAnim.js